import { useEffect } from "react";
import ReactLoading from "react-loading";

export const FormLoading = ({
  show,
  content,
}: {
  show: boolean;
  content?: string;
}) => {
  useEffect(() => {
    if (!show) return;

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(255, 255, 255, 0.12)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
      }}
    >
      <div
        style={{
          textAlign: "center",
          background: "rgba(0, 0, 0, .7)",
          borderRadius: 12,
          padding: "32px 32px",
          maxWidth: 400,
          boxShadow: "0 4px 12px rgba(0, 0, 0, .2)",
        }}
      >
        <ReactLoading type="bubbles" color="#bbb" width={36} height={36} />
        {content && (
          <div
            style={{
              color: "#fff",
              cursor: "default",
            }}
          >
            {content}
          </div>
        )}
      </div>
    </div>
  );
};
